module.exports = __webpack_public_path__ + "static/peryton-2be51ebb8045834877909ca57e81a694.jpeg";